export const fragmentTypes = {
  Game: ['FalkorGame'],
  Cloudinary: ['CloudinaryImage', 'CloudinaryVideo'],
  PlayerStatus: ['FalkorPlayerGameState'],
  Round: ['FalkorRound'],
  Subround: ['FalkorSubround'],
  Metric: [
    'FalkorCaptionedPhotoMetric',
    'FalkorMediaMetric',
    'WorkoutMetric',
    'FalkorStepsMetric',
  ],
  Activity: [
    'FalkorCaptionedPhotoActivity',
    'FalkorCardioActivity',
    'FalkorMediaActivity',
    'FalkorMinPaceDistanceActivity',
    'FalkorMinPaceDurationActivity',
  ],
  GameRound: ['FalkorRound'],
  PageInfo: ['KeysetPageInfo', 'OffsetPageInfo'],
  GameBoard: ['FalkorGameBoard'],
  GameBoardPlayer: ['FalkorGameBoardPlayer'],
  OrderItem: [
    'ChipsOrderItem',
    'GameBetOrderItem',
    'GameOrderItem',
    'MembershipOrderItem',
    'OpRegistrationFeeOrderItem',
    'OpSideBetOrderItem',
    'OpVirtualGiftsOrderItem',
    'OpWeighInTokensOrderItem',
    'PointsOrderItem',
    'PromoOrderItem',
  ],
  GameProfile: ['FalkorGameProfile'],
  MembershipOffer: [],
  RepeatingGameSpecStartCadence: [
    'RepeatingGameSpecAfterPredecessorStartDateStartCadence',
  ],
  RepeatingGameSpecVisibilityCadence: [
    'RepeatingGameSpecBeforeStartDateVisibilityCadence',
  ],
  Interval: [],
  UserGameStatus: ['FalkorUserGameStatus'],
  IntervalPlayerStatus: [
    'FalkorRoundPlayerStatus',
    'FalkorSubroundPlayerStatus',
  ],
  CreateMetricResult: [
    'FalkorCaptionedPhotoMetric',
    'FalkorMediaMetric',
    'WorkoutMetric',
  ],
  FalkorMedia: ['CloudinaryVideo', 'CloudinaryImage'],
  ScheduledPostSpecPublishAtMilestone: [
    'ScheduledPostSpecPublishAtGameMilestone',
    'ScheduledPostSpecPublishAtRoundMilestone',
  ],
  FalkorMediaActivityConfig: ['FalkorMediaVideoActivityConfig'],
};
